export interface Imodule {
    ModuleID: number;
    Name: string;
    AplicacionID: number;
    Descripcion: string;
    Status: boolean;
    UserCreation: string;
    DateCreation: string;
    UserLastUpdate: string;
    DateLastUpdate: string;
    StatusName: string;
}

export class Module implements Imodule {
    constructor(
        public ModuleID: number,
        public Name: string,
        public AplicacionID: number,
        public Descripcion: string,
        public Status: boolean,
        public UserCreation: string,
        public DateCreation: string,
        public UserLastUpdate: string,
        public DateLastUpdate: string,
        public StatusName: string
    ) {

        this.ModuleID = ModuleID;
        this.AplicacionID = AplicacionID;
        this.Name = Name;
        this.Descripcion = Descripcion;
        this.Status = Status;
        this.UserCreation = UserCreation;
        this.DateCreation = DateCreation;
        this.UserLastUpdate = UserLastUpdate;
        this.DateLastUpdate = DateLastUpdate;
        this.StatusName = StatusName;
    }
}
